// @flow
import type { ModularUIErrorResponse } from "./FetchException";

/**
 * UnauthorizedException
 */
class UnauthorizedException extends Error {
  status: number;
  id: string;
  response: ?ModularUIErrorResponse;

  constructor(
    url: string,
    method: string,
    errorResponse: ?ModularUIErrorResponse,
  ) {
    super(`Cannot request resource ${url} with method ${method}`);

    this.name = "UnauthorizedException";
    this.id = "UnauthorizedException";
    this.status = 401;
    this.response = errorResponse;
  }
}

export default UnauthorizedException;
